import { Button, Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import KenInputField from '../../../../../global_components/KenInputField';
import { makeStyles } from '@material-ui/styles';

const stylebtn = {
  // fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '14px',
  lineHeight: '20px',
  /* identical to box height, or 143% */
  textAlign: 'center',
  color: '#00218D',
  marginRight: '10px',
  borderRadius: '3px',
  alignItems: 'center',
  padding: '8px 12px',
};
const inputArr = [
  {
    type: 'text',
    id: 1,
    value: '',
  },
];
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',

    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    marginBottom: '15px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  modalHeader: {
    fontWeight: 'normal',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '25px',
    },
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    borderBottom: '1px solid transparent',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid transparent',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: '#EB5757',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  normal: {
    color: '#FFFFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  editbtn: {
    color: '#FFFFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '100px',
  },
  Blue: {
    color: '#FFFFFF',
    background: '#00218D',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '70%',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  sameLine: {
    marginTop: '40px',
    marginLeft: '-10px',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));
const GradingComponent = () => {
  const classes = useStyles();
  const [arr, setArr] = useState([]);
  const [btnName, setbtnName] = useState('');
  const [btnState, setBtnState] = useState([]);
  const [minimumComponent, setMinimumComponent] = useState('40');
  const [minimumWeightage, setMinimumWeightage] = useState('0');
  const [maximumComponent, setMaximumComponent] = useState('100');
  const [maximumWeightage, setMaximumWeightage] = useState('100');
  const addInput = () => {
    setArr((s) => {
      return [
        ...s,
        {
          type: 'text',
          value: '',
        },
      ];
    });
  };
  const handleMaximumWeight = (e) => {
    setMaximumWeightage(e.target.value);
  };
  const handleMinimumWeight = (e) => {
    setMinimumWeightage(e.target.value);
  };
  const handleMinimumComponent = (e) => {
    setMinimumComponent(e.target.value);
  };
  const handleMaximumComponent = (e) => {
    setMaximumComponent(e.target.value);
  };
  const handleChange = (e) => {
    e.preventDefault();

    const index = e.target.id;

    setArr((s) => {
      const newArr = s.slice();
      newArr[index].value = e.target.value;
      setbtnName(newArr[index].value);

      return newArr;
    });
  };

  const handleTest1 = (buttonid) => {
    console.log('buttonid', buttonid);
    if (buttonid === 1) {
      setMinimumComponent(40);
      setMinimumWeightage(0);
      setMaximumComponent(100);
      setMaximumWeightage(100);
    }
    if (buttonid === 2) {
      setMinimumComponent(40);
      setMinimumWeightage(0);
      setMaximumComponent(100);
      setMaximumWeightage(100);
    }
    if (buttonid === 3) {
      setMinimumComponent(40);
      setMinimumWeightage(0);
      setMaximumComponent(100);
      setMaximumWeightage(100);
    }
    if (buttonid === 4) {
      setMinimumComponent(40);
      setMinimumWeightage(0);
      setMaximumComponent(100);
      setMaximumWeightage(100);
    }
  };
  const handleButton = () => {
    const ele = (
      <Button
        variant="contained"
        style={stylebtn}
        onClick={() => handleTest1(btnState.length + 1)}
      >
        {btnName}
      </Button>
    );
    setBtnState([...btnState, ele]);
    setbtnName('');
    setArr([]);
  };

  const handleButtonCancel = () => {
    setArr([]);
  };
  const ele = (
    <Button
      variant="contained"
      style={stylebtn}
      onClick={() => handleTest1(btnState.length + 1)}
    >
      {btnName}
    </Button>
  );
  // {
  //   btnName && setBtnState([...btnState, ele]);
  // }

  return (
    <>
      <Typography variant="h6" className={classes.title}>
        Grading component master list
      </Typography>
      <div>
        {arr.map((item, i) => {
          return (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4}>
                <KenInputField
                  label={'Button Component'}
                  optionalLabel={false}
                  value={item.value}
                  id={i}
                  onChange={handleChange}
                  style={{ fontSize: 12 }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
                style={{ marginTop: '20px', marginLeft: '10px' }}
              >
                <Button
                  variant="contained"
                  style={stylebtn}
                  onClick={() => handleButton(i)}
                >
                  Save
                </Button>{' '}
                <Button
                  variant="contained"
                  style={stylebtn}
                  onClick={() => handleButtonCancel(i)}
                >
                  Cancel
                </Button>{' '}
              </Grid>
            </Grid>
          );
        })}

        <Button
          variant="contained"
          style={stylebtn}
          onClick={() => handleTest1(1)}
        >
          TEST 1
        </Button>
        <Button
          variant="contained"
          style={stylebtn}
          onClick={() => handleTest1(2)}
        >
          TEST 2
        </Button>
        <Button
          variant="contained"
          style={stylebtn}
          onClick={() => handleTest1(3)}
        >
          MID TERM
        </Button>
        <Button
          variant="contained"
          style={stylebtn}
          onClick={() => handleTest1(4)}
        >
          END TERM
        </Button>
        {btnState}
        <Button variant="contained" style={stylebtn} onClick={addInput}>
          +
        </Button>
      </div>
      <Grid container spacing={2} className={classes.sameLine}>
        <Grid item xs={12} sm={5}>
          <KenInputField
            label={'Minimum Component'}
            optionalLabel={false}
            // rows={4}
            // multiline={true}
            value={minimumComponent}
            onChange={(e) => handleMinimumComponent(e)}
            style={{ fontSize: 12 }}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <KenInputField
            label={'Minimum Weightage (%)'}
            optionalLabel={false}
            // rows={4}
            // multiline={true}
            value={minimumWeightage}
            onChange={(e) => handleMinimumWeight(e)}
            style={{ fontSize: 12 }}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <KenInputField
            label={'Maximum Components'}
            optionalLabel={false}
            // rows={4}
            // multiline={true}
            value={maximumComponent}
            onChange={(e) => handleMaximumWeight(e)}
            style={{ fontSize: 12 }}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <KenInputField
            label={'Maximum Weightage (%)'}
            optionalLabel={false}
            // rows={4}
            // multiline={true}
            value={maximumWeightage}
            onChange={(e) => handleMaximumWeight(e)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default GradingComponent;
